import {
  Balloon,
  Button,
  Checkbox,
  Dialog,
  Form,
  Input,
  Message,
  Select,
  Table,
} from '@alifd/next';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';
const { Item } = Form;
const AccountUserList = (props) => {
  //頁面權限設定
  const users = client.service('userHealth');
  const [usersArr, setUsersArr] = useState([]);
  const [usersArrAll, setUsersArrAll] = useState([]);
  const [email, setEmail] = useState('');
  const [auth, setAuth] = useState('');
  const [password, setPassword] = useState('');
  const [userEditIndex, setUserEditIndex] = useState(null);
  const [userActiveIndex, setUserActiveIndex] = useState(null);
  const [userEditDialog, setUserEditDialog] = useState(false);
  const [userActiveDialog, setUserActiveDialog] = useState(false);

  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfidDialog, setRfidDialog] = useState(false);
  const [rfidDisplay, setRfidDisplay] = useState('');
  const [curdataIndex, setcurDataIndex] = useState('createTime');
  const [curorder, setcurOrder] = useState('asc');

  //取得userGroup name data
  const [userAuthArr, setUserAuthArr] = useState([]);
  // console.log(userAuthArr)
  useEffect(() => {
    const userGroup = client.service('userGroup');
    const result = userGroup.find({}).then((result) => {
      setUserAuthArr(
        result.data.map((item) => {
          return item.name;
        })
      );
    });
  }, []);

  //查詢
  function usersFind(para) {
    return new Promise((resolve, reject) => {
      try {
        users.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  //新增
  function usersCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        users.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //更新
  function usersUpdate(id, obj, params) {
    return new Promise((resolve, reject) => {
      users
        .patch(id, obj, params)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  //刪除
  function usersRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        users.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  const serverUsersUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    usersFind({}).then((result) => {
      const sortedArr = result.sort((a, b) => {
        const result = (
          typeof a[rdataIndex] === 'number'
            ? a[rdataIndex].toString()
            : a[rdataIndex]
        ).localeCompare(
          typeof b[rdataIndex] === 'number'
            ? b[rdataIndex].toString()
            : b[rdataIndex]
        );
        return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
      });

      setUsersArr(sortedArr);

      setUsersArrAll(sortedArr);
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverUsersUpdate(dataIndex, order);
  };

  useEffect(() => {
    serverUsersUpdate();
  }, []);

  function makeid(length) {
    let result = '';
    let characters = '0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function createNewPassword(record) {
    //  console.log(record)
    Swal.fire({
      title: `信箱:${record.email}\n用戶名:${record.name}\n確認幫此帳號產生新密碼?`,
      text: '重新產生一組新密碼，會取代原密碼，請管理員注意(建議此動作為住戶遺失密碼時操作)',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#BEBEBE',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.isConfirmed) {
        const num = makeid(6);
        axios('/ezcon/api/resetPassword', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: {
            email: record.email,
            password: num,
          },
        })
          .then((res) => {
            console.log('Success:', res);
            if (res.status === 200) {
              Message.success('密碼重設成功');
              Swal.fire('成功!', `此帳號新密碼:${num}`, 'success');
            }
          })
          .catch((error) => {
            console.error('Error', error);
            Message.error('密碼重設失敗');
          });
      }
    });
  }

  function searchRender(value) {
    //input search filter
    if (value.length > 0) {
      const sortedArr = [...usersArrAll]
        .map((e) => {
          let hasIncludes = false;
          Object.keys(e).forEach((ee) => {
            let val2 = e[ee];
            if (val2.toString().includes(value)) hasIncludes = true;
          });
          if (hasIncludes) return e;
          return false;
        })
        .filter((e) => e !== false);

      setUsersArr([...sortedArr]);
    } else {
      setUsersArr([...usersArrAll]);
    }
  }

  return (
    <>
      {/* 編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userEditDialog}
        onOk={() => {
          let item = usersArr[userEditIndex];
          item.auth = auth;

          Swal.fire({
            title: `確定修改(${item.email})帳號?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', '此帳號修改成功', 'success');

              usersUpdate(item._id, item)
                .then((res) => {
                  console.log('==users update success:', res);
                  Message.success('更新成功');
                  serverUsersUpdate();
                  setAuth('');
                  setUserEditDialog(false);
                })
                .catch((error) => {
                  console.log('==users update fail:', error);
                  Message.error(`${error}`);
                });
            }
          });
        }}
        onCancel={() => {
          setAuth('');

          setUserEditDialog(false);
        }}
        onClose={() => {
          setAuth('');

          setUserEditDialog(false);
        }}
      >
        <div>
          <h3>編輯頁面權限設定</h3>
          <Form.Item label="權限設定">
            <Checkbox.Group
              value={auth.split(',')}
              dataSource={userAuthArr}
              onChange={(value) => {
                setAuth(value.join(','));
              }}
            />
          </Form.Item>
        </div>
      </Dialog>

      {/* 開通 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userActiveDialog}
        onOk={() => {
          let obj = usersArr[userActiveIndex];
          let objLength = Object.keys(obj).length;
          if (barcodeDisplay) obj.barcodeType = barcodeDisplay;
          if (rfidDisplay) obj.rfidType = rfidDisplay;
          if (!barcodeDisplay && !rfidDisplay) {
            // console.log('errors: 請開通條碼及磁扣',);
            Message.error('請開通條碼及磁扣');
            return;
          } else {
            delete obj.password;
            usersUpdate(obj._id, obj, { query: { type: 'judgeCards' } })
              .then((res) => {
                console.log('==residentrActive update success:', res);
                Message.success('開通成功');

                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');

                setUserActiveDialog(false);
              })
              .catch((error) => {
                console.log('==residentActive update fail:', error);
                Message.error(`${error}`);
                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');
              });
          }
        }}
        onCancel={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
        onClose={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
      >
        <h1>請開通用戶條碼及磁扣</h1>

        <img
          width={300}
          height={200}
          src={`/ezcon/img/Barcode.jpg`}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setBarcodeDialog(true);
          }}
        />
        <div>值:{barcodeDisplay}</div>

        <Dialog
          hasMask
          visible={barcodeDialog}
          footer={false}
          onClose={() => {
            setBarcodeDisplay('');
            setBarcodeDialog(false);
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setBarcodeDisplay(data);
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setBarcodeDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="barcodeDisplay"
                value={barcodeDisplay}
                onChange={(value) => {
                  setBarcodeDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(barcodeDisplay)) {
                    Message.success('掃描成功');
                    setBarcodeDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setBarcodeDialog(true);
                  }
                }}
              />
            </Item>
            <br />
            <img
              src={`/ezcon/img/Barcode.jpg`}
              alt="barcode"
              type="cover"
              width={400}
              height={300}
            ></img>

            <h1>請掃描條碼...</h1>
          </Form>
        </Dialog>

        <img
          width={300}
          height={200}
          src={`/ezcon/img/Rfid.jpg`}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setRfidDialog(true);
          }}
        />
        <div>值:{rfidDisplay}</div>

        <Dialog
          hasMask
          visible={rfidDialog}
          footer={false}
          onClose={() => {
            setRfidDialog(false);
            setRfidDisplay('');
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setRfidDisplay(data);
                  Message.success('掃描成功');
                  setRfidDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setRfidDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="rfidDisplay"
                value={rfidDisplay}
                onChange={(value) => {
                  setRfidDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(rfidDisplay)) {
                    Message.success('掃描成功');
                    setRfidDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setRfidDialog(true);
                  }
                }}
              />
            </Item>

            <br />
            <img
              className={styles.barcode}
              src={`/ezcon/img/Rfid.jpg`}
              alt="rfid"
              type="cover"
              width={400}
              height={300}
            ></img>

            <h1>請掃描磁扣/卡片...</h1>
          </Form>
        </Dialog>
      </Dialog>

      {/* filter搜尋 */}
      <Input
        className={styles.input}
        size="large"
        placeholder="輸入搜尋文字"
        onChange={searchRender}
        aria-label="this is input"
      />

      <Table dataSource={usersArr} onSort={onTableSort}>
        <Table.Column
          sortable
          title="建立時間"
          dataIndex="createTime"
          width={150}
          cell={(record, index) => {
            return <>{new Date(usersArr[index].createTime).toLocaleString()}</>;
          }}
        />
        <Table.Column
          sortable
          title="戶號"
          dataIndex="householdNumber"
          width={150}
        />
        <Table.Column sortable title="姓名" dataIndex="name" width={150} />
        <Table.Column sortable title="收縮壓" dataIndex="收縮壓" width={150} />
        <Table.Column sortable title="舒張壓" dataIndex="舒張壓" width={150} />
        <Table.Column
          sortable
          title="平均血壓"
          dataIndex="平均血壓"
          width={150}
        />
        <Table.Column sortable title="脈拍數" dataIndex="脈拍數" width={150} />
        <Table.Column sortable title="身高" dataIndex="身高" width={150} />
        <Table.Column sortable title="體重" dataIndex="體重" width={150} />
        <Table.Column sortable title="BMI" dataIndex="BMI" width={150} />
      </Table>
    </>
  );
};

export default AccountUserList;
